import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./captcha.templates";

const decorator = (Story) => html`
    <form>
        ${Story()}
        <ux-button type="submit" variant="primary" class="ux-u-mt-s"
            >Submit Form</ux-button
        >
    </form>
`;

export default {
    title: "Components/Captcha",
    component: "ux-iws-captcha",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        sitekey: {
            control: { type: "text" },
        },
        language: {
            control: { type: "select" },
            options: ["en", "de"],
        },
        preventSubmit: {
            control: { type: "booleam" },
        },
    },
    args: {
        sitekey: "FCMJCSQ29M7LEOV4",
        language: "de",
        preventSubmit: true,
        onUxCaptcha: (event) => {
            console.log(event.type, event.detail?.status, event.detail?.error);
        },
    },
};

export const Default = {};
